import Vuex from 'vuex';
import Vue from 'vue';
import largeSidebar from './modules/largeSidebar';
import config from './modules/config';
import auth from './modules/auth';
import users from './modules/users';
import taxpayers from './modules/taxpayers';
import managers from './modules/managers';
import manager_dashboard from './modules/manager_dashboard';
import documents from './modules/documents';
import taxpayer_documents from './modules/taxpayer_documents';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    largeSidebar,
    config,
    auth,
    users,
    taxpayers,
    managers,
    manager_dashboard,
    documents,
    taxpayer_documents,
  },
});
